import { render, staticRenderFns } from "./ConfigDataMartsResynchConfirmation.vue?vue&type=template&id=6157f89a&scoped=true&"
import script from "./ConfigDataMartsResynchConfirmation.vue?vue&type=script&lang=js&"
export * from "./ConfigDataMartsResynchConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDataMartsResynchConfirmation.vue?vue&type=style&index=0&id=6157f89a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6157f89a",
  null
  
)

export default component.exports